import { useAuthStore } from "../stores/authStore";

interface Props {
  permission: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export default function PermissionGate({ permission, children, fallback = null }: Props) {
  const { hasPermission } = useAuthStore();
  if (!hasPermission(permission)) return <>{fallback}</>;
  return <>{children}</>;
}
